// One row per flag shipped in `public/images/countries`. Dial prefixes are
// shared (+7 is RU and KZ, +1 is US, CA and DO), and `/v4/region` answers with
// a prefix rather than a country, so the order matters: the first row carrying
// a prefix is the one a geo answer resolves to. The frequently used countries
// are kept at the top for that reason, the rest follow alphabetically.
//
// `WD` is not a country but the "another country" row, and must stay last: it
// carries a bare `+`, so the patient types the whole international number, and
// it doubles as the row a prefix outside this list is displayed against.
export const countries = [
    { code: "+7", value: "RU", fullName: "common.phoneFormats.RU.name" },
    { code: "+972", value: "IL", fullName: "common.phoneFormats.IL.name" },
    { code: "+1", value: "US", fullName: "common.phoneFormats.US.name" },
    { code: "+7", value: "KZ", fullName: "common.phoneFormats.KZ.name" },
    { code: "+380", value: "UA", fullName: "common.phoneFormats.UA.name" },
    { code: "+375", value: "BY", fullName: "common.phoneFormats.BY.name" },
    { code: "+49", value: "DE", fullName: "common.phoneFormats.DE.name" },
    { code: "+90", value: "TR", fullName: "common.phoneFormats.TR.name" },
    { code: "+44", value: "GB", fullName: "common.phoneFormats.GB.name" },
    { code: "+971", value: "AE", fullName: "common.phoneFormats.AE.name" },
    { code: "+886", value: "TW", fullName: "common.phoneFormats.TW.name" },
    { code: "+998", value: "UZ", fullName: "common.phoneFormats.UZ.name" },
    { code: "+996", value: "KG", fullName: "common.phoneFormats.KG.name" },
    { code: "+992", value: "TJ", fullName: "common.phoneFormats.TJ.name" },
    { code: "+376", value: "AD", fullName: "common.phoneFormats.AD.name" },
    { code: "+93", value: "AF", fullName: "common.phoneFormats.AF.name" },
    { code: "+374", value: "AM", fullName: "common.phoneFormats.AM.name" },
    { code: "+43", value: "AT", fullName: "common.phoneFormats.AT.name" },
    { code: "+61", value: "AU", fullName: "common.phoneFormats.AU.name" },
    { code: "+994", value: "AZ", fullName: "common.phoneFormats.AZ.name" },
    { code: "+32", value: "BE", fullName: "common.phoneFormats.BE.name" },
    { code: "+359", value: "BG", fullName: "common.phoneFormats.BG.name" },
    { code: "+973", value: "BH", fullName: "common.phoneFormats.BH.name" },
    { code: "+1", value: "CA", fullName: "common.phoneFormats.CA.name" },
    { code: "+41", value: "CH", fullName: "common.phoneFormats.CH.name" },
    { code: "+86", value: "CN", fullName: "common.phoneFormats.CN.name" },
    { code: "+357", value: "CY", fullName: "common.phoneFormats.CY.name" },
    { code: "+420", value: "CZ", fullName: "common.phoneFormats.CZ.name" },
    { code: "+45", value: "DK", fullName: "common.phoneFormats.DK.name" },
    { code: "+1", value: "DO", fullName: "common.phoneFormats.DO.name" },
    { code: "+213", value: "DZ", fullName: "common.phoneFormats.DZ.name" },
    { code: "+372", value: "EE", fullName: "common.phoneFormats.EE.name" },
    { code: "+20", value: "EG", fullName: "common.phoneFormats.EG.name" },
    { code: "+34", value: "ES", fullName: "common.phoneFormats.ES.name" },
    { code: "+358", value: "FI", fullName: "common.phoneFormats.FI.name" },
    { code: "+33", value: "FR", fullName: "common.phoneFormats.FR.name" },
    { code: "+995", value: "GE", fullName: "common.phoneFormats.GE.name" },
    { code: "+30", value: "GR", fullName: "common.phoneFormats.GR.name" },
    { code: "+385", value: "HR", fullName: "common.phoneFormats.HR.name" },
    { code: "+36", value: "HU", fullName: "common.phoneFormats.HU.name" },
    { code: "+62", value: "ID", fullName: "common.phoneFormats.ID.name" },
    { code: "+353", value: "IE", fullName: "common.phoneFormats.IE.name" },
    { code: "+91", value: "IN", fullName: "common.phoneFormats.IN.name" },
    { code: "+964", value: "IQ", fullName: "common.phoneFormats.IQ.name" },
    { code: "+98", value: "IR", fullName: "common.phoneFormats.IR.name" },
    { code: "+39", value: "IT", fullName: "common.phoneFormats.IT.name" },
    { code: "+81", value: "JP", fullName: "common.phoneFormats.JP.name" },
    { code: "+855", value: "KH", fullName: "common.phoneFormats.KH.name" },
    { code: "+82", value: "KR", fullName: "common.phoneFormats.KR.name" },
    { code: "+961", value: "LB", fullName: "common.phoneFormats.LB.name" },
    { code: "+94", value: "LK", fullName: "common.phoneFormats.LK.name" },
    { code: "+370", value: "LT", fullName: "common.phoneFormats.LT.name" },
    { code: "+352", value: "LU", fullName: "common.phoneFormats.LU.name" },
    { code: "+371", value: "LV", fullName: "common.phoneFormats.LV.name" },
    { code: "+212", value: "MA", fullName: "common.phoneFormats.MA.name" },
    { code: "+373", value: "MD", fullName: "common.phoneFormats.MD.name" },
    { code: "+382", value: "ME", fullName: "common.phoneFormats.ME.name" },
    { code: "+389", value: "MK", fullName: "common.phoneFormats.MK.name" },
    { code: "+976", value: "MN", fullName: "common.phoneFormats.MN.name" },
    { code: "+960", value: "MV", fullName: "common.phoneFormats.MV.name" },
    { code: "+52", value: "MX", fullName: "common.phoneFormats.MX.name" },
    { code: "+258", value: "MZ", fullName: "common.phoneFormats.MZ.name" },
    { code: "+31", value: "NL", fullName: "common.phoneFormats.NL.name" },
    { code: "+47", value: "NO", fullName: "common.phoneFormats.NO.name" },
    { code: "+64", value: "NZ", fullName: "common.phoneFormats.NZ.name" },
    { code: "+507", value: "PA", fullName: "common.phoneFormats.PA.name" },
    { code: "+48", value: "PL", fullName: "common.phoneFormats.PL.name" },
    { code: "+351", value: "PT", fullName: "common.phoneFormats.PT.name" },
    { code: "+40", value: "RO", fullName: "common.phoneFormats.RO.name" },
    { code: "+381", value: "RS", fullName: "common.phoneFormats.RS.name" },
    { code: "+966", value: "SA", fullName: "common.phoneFormats.SA.name" },
    { code: "+248", value: "SC", fullName: "common.phoneFormats.SC.name" },
    { code: "+46", value: "SE", fullName: "common.phoneFormats.SE.name" },
    { code: "+65", value: "SG", fullName: "common.phoneFormats.SG.name" },
    { code: "+386", value: "SI", fullName: "common.phoneFormats.SI.name" },
    { code: "+66", value: "TH", fullName: "common.phoneFormats.TH.name" },
    { code: "+993", value: "TM", fullName: "common.phoneFormats.TM.name" },
    { code: "+216", value: "TN", fullName: "common.phoneFormats.TN.name" },
    { code: "+58", value: "VE", fullName: "common.phoneFormats.VE.name" },
    { code: "+84", value: "VN", fullName: "common.phoneFormats.VN.name" },
    { code: "+27", value: "ZA", fullName: "common.phoneFormats.ZA.name" },
    { code: "+263", value: "ZW", fullName: "common.phoneFormats.ZW.name" },
    { code: "+", value: "WD", fullName: "common.phoneFormats.WD.name" },
];
